import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { loadDailyNewUsersAsync, selectDailyNewUsers } from '../dashboardSlice';
import { StatCard } from './StatCard';

// Últimos 14 dias pra curva de área — dado real (mesma série de 90 dias já
// usada pelo DailyNewUsersChart), só recorta a janela mais recente.
const SPARKLINE_DAYS = 14;

export const NewUsersTodayCard = () => {
    const dispatch = useDispatch();
    const routerHistory = useHistory();
    const { data, status } = useSelector(selectDailyNewUsers);

    useEffect(() => {
        dispatch(loadDailyNewUsersAsync());
    }, [dispatch]);

    const { today, history } = useMemo(() => {
        if (!Array.isArray(data) || !data.length) return { today: 0, history: [] };
        const recent = data.slice(-SPARKLINE_DAYS);
        return {
            today: data[data.length - 1]?.newUsers ?? 0,
            history: recent.map(d => d.newUsers),
        };
    }, [data]);

    return (
        <StatCard
            label="Novos usuários"
            secondary="Hoje"
            icon="pi-user-plus"
            color="var(--green-500)"
            value={today}
            loading={status === 'idle'}
            history={history}
            onClick={() => routerHistory.push('/users', { preset: 'newToday', presetLabel: 'Novos usuários hoje' })}
        />
    );
};
